import { en as common } from "./common.js";
import { en as auth } from "./auth.js";
import { en as emails } from "./emails.js";
import { en as shared } from "./shared.js";
import { en as errors } from "./errors.js";
import { en as nav } from "./nav.js";
import { en as notifications } from "./notifications.js";
import { en as preferences } from "./preferences.js";
import { en as profile } from "./profile.js";
import { en as activities } from "./activities.js";
import { en as customers } from "./customers.js";
import { en as settings } from "./settings.js";
import { en as reports } from "./reports.js";
import { en as billing } from "./billing.js";
import { en as triggers } from "./triggers.js";
import { en as labels } from "./labels.js";

export const en = {
  common,
  auth,
  emails,
  shared,
  errors,
  nav,
  notifications,
  preferences,
  profile,
  activities,
  customers,
  settings,
  reports,
  billing,
  triggers,
  labels,
};
